import React from "react";
import { Card } from "antd";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
} from "recharts";

const config = {
  departments: [
    { name: "Dept1", value: 900 },
    { name: "Dept2", value: 800 },
    { name: "Dept3", value: 700 },
    { name: "Dept4", value: 600 },
    { name: "Dept5", value: 550 },
  ],
  ratings: [
    { name: "Outstanding", value: 45, color: "#52c41a" },
    { name: "Good", value: 30, color: "#fadb14" },
    { name: "Average", value: 15, color: "#fa8c16" },
    { name: "Poor", value: 10, color: "#ff4d4f" },
  ],
};

const PerformanceDashboard: React.FC = () => {
  return (
    <div className="grid grid-cols-12 gap-4 mt-4">
      {/* Bar Chart Card */}
      <Card
        title="Department-wise Average Performance Rating"
        className="col-span-7 rounded-xl"
      >
        <div className="h-[260px]">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              data={config.departments}
              layout="vertical"
              margin={{ top: 10, right: 20, left: 20, bottom: 10 }}
            >
              <XAxis
                type="number"
                domain={[500, 900]}
                ticks={[500, 600, 700, 800, 900]}
                tickFormatter={(v) => `≤ ${v}`}
              />
              <YAxis type="category" dataKey="name" />
              <Bar dataKey="value" barSize={18} radius={[6, 6, 6, 6]} fill="#1677ff" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </Card>

      {/* Donut Chart Card */}
      <Card
        title="Employee Rating Distribution"
        className="col-span-5 rounded-xl relative"
      >
        <div className="flex h-[260px] items-center">
          {/* Chart */}
          <div className="w-1/2 h-full flex items-center justify-center">
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie
                  data={config.ratings}
                  dataKey="value"
                  nameKey="name"
                  innerRadius={60}
                  outerRadius={90}
                  cx="50%"
                  cy="50%"
                >
                  {config.ratings.map((entry, index) => (
                    <Cell key={index} fill={entry.color} />
                  ))}
                </Pie>
              </PieChart>
            </ResponsiveContainer>
          </div>

          {/* Legend */}
          <div className="w-1/2 flex flex-col justify-end space-y-3">
            {config.ratings.map((r) => (
              <div key={r.name} className="flex items-center gap-2 text-sm">
                <span
                  className="h-3 w-3 rounded-sm"
                  style={{ backgroundColor: r.color }}
                />
                <span>{r.name}</span>
              </div>
            ))}
          </div>
        </div>
      </Card>
    </div>
  );
};

export default PerformanceDashboard;
